<main *ngIf="isPageLoad">
  <section
    class="left app-bg {{ loginType }}-login-page"
    [style.filter]="this.colorAnimation.hueRotate$ | async"
  >
    <div class="narrow-content">
      <img class="logo" [class.higher]="environmentSite !== 'platform'" src="assets/logo.svg" />
      <ng-container *ngIf="environmentSite === 'platform'; else community">
        <div class="welcome-text">{{ currentLoginType?.welcomeText }}</div>
        <div class="title-text">{{ currentLoginType.title }}</div>
      </ng-container>
      <ng-template #community>
        <img src="assets/sustainability-for-everyone.png" style="width: 100%" />
      </ng-template>
    </div>
  </section>

  <section class="right">
    <div class="narrow-content">
      <ng-container *ngIf="environmentSite === 'community'">
        <img class="welcome-image" src="assets/areas.gif" style="width: 100%" />
      </ng-container>

      <ng-container *ngIf="environmentSite === 'platform'">
        <img *ngIf="loginType !== 'zendesk'" class="welcome-image" src="assets/growth.png" />
        <img *ngIf="loginType === 'zendesk'" class="welcome-image" src="assets/meditate.png" />
      </ng-container>

      <lgn-notification
        *ngIf="notification$ | async as notification"
        [notification]="notification"
      ></lgn-notification>
      <router-outlet></router-outlet>
    </div>
  </section>
</main>

<footer *ngIf="isPageLoad">
  <section
    class="left app-bg {{ loginType }}-login-footer"
    [style.filter]="this.colorAnimation.hueRotate$ | async"
  >
    <div class="narrow-content">
      <div class="link-label">Looking for our website?</div>
      <a class="link-url" [href]="ethicLandingLink" target="_blank">ethic.com</a>
    </div>
  </section>

  <section class="right"></section>
</footer>
